import React from "react";

class IconCheck extends React.Component {
    render() {
        return (
            <svg
                className="icon--check"
                viewBox="0 0 18 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M17,5.34343434 C17,5.5959596 16.8967742,5.84848485 16.7109677,6.03030303 L7.83354839,14.7171717 C7.64774194,14.8989899 7.38967742,15 7.1316129,15 C6.87354839,15 6.61548387,14.8989899 6.42967742,14.7171717 L1.28903226,9.68686869 C1.10322581,9.50505051 1,9.25252525 1,9 C1,8.74747475 1.10322581,8.49494949 1.28903226,8.31313131 L2.69290323,6.93939394 C2.87870968,6.75757576 3.13677419,6.65656566 3.39483871,6.65656566 C3.65290323,6.65656566 3.91096774,6.75757576 4.09677419,6.93939394 L7.1316129,9.91919192 L13.9032258,3.28282828 C14.0890323,3.1010101 14.3470968,3 14.6051613,3 C14.8632258,3 15.1212903,3.1010101 15.3070968,3.28282828 L16.7109677,4.65656566 C16.8967742,4.83838384 17,5.09090909 17,5.34343434 Z"
                        fill="currentColor"
                    />
                </g>
            </svg>
        );
    }
}

export default IconCheck;



// WEBPACK FOOTER //
// ./src/components/icons/IconCheck.jsx